import React from "react";
import styes from "./st.module.scss";

import img1 from "./images/img.png";
import HeaderCompusWithImage from "../../../../Common/HeaderCompusWithImage/HeaderCompusWithImage";
import LeftColoredTitle from "../../../../components/Titles/LeftColoredTitle";

export const PolitiqueQualityHeader = () => {
  return (
    <HeaderCompusWithImage
      images={[img1]}
      title="Politique assurance qualité de l’UIK"
    />
  );
};

function PolitiqueQuality() {
  return (
    <div className={styes.main}>
      <LeftColoredTitle>Politique assurance qualité de l’UIK</LeftColoredTitle>

      <br />
      <br />

      <p className={styes.description}>
        Soucieuse de la satisfaction de ses apprenants, de son personnel
        pédagogique, de son personnel administratif, des parents et de ses
        différentes parties intéressées pertinentes, l’UIK s’est engagé dans une
        démarche d’amélioration continue qui lui garantit le maintien d’un haut
        niveau de satisfaction.
      </p>

      <p className={styes.description}>
        Dans cette perspective, l’UIK s’est engagée dans une démarche
        d’amélioration continue soutenue par la mise en œuvre effective d’un
        système de management conforme aux exigence de la norme{" "}
        <strong className="color-main">ISO21001</strong> norme internationale
        dédiée spécifiquement aux établissements d’enseignement.
      </p>

      <p className={styes.description}>
        Spécialisé dans la formation et l’accompagnement de ses étudiants, l’UIK
        a pour ambition de former des acteurs économiques, des citoyens de
        premier plan et des entrepreneurs, performants et capables d’agir dans
        un contexte international complexe et dynamique à travers des
        enseignants et un personnel qualifiés et des programmes innovants dans
        un environnement agréable, stimulant et multilingue. Notre établissement
        a pour ambition d’être une université d’excellence et d’innovation,
        reconnue en Tunisie et dans la région, qui forme des leaders compétents
        et éthiques, capables de relever les défis complexes du monde moderne et
        de contribuer positivement à la société.
      </p>

      <h3 className={styes.h4}>
        En adéquation avec cette vision, notre politique s’articule autour des
        orientations suivantes :
      </h3>

      <p className={styes.description}>
        <strong className="color-main">
          ► Assurer une formation d’excellence :
        </strong>{" "}
        A travers le suivi des évolutions pédagogiques, didactiques,
        scientifiques et techniques pertinentes, le développement de l'activité
        de la recherche scientifique en s’appuyant sur un système de management
        certifié et des parcours accrédités.
      </p>

      <p className={styes.description}>
        <strong className="color-main">
          ► Accompagner l’insertion et l’employabilité :
        </strong>{" "}
        En améliorant la réussite et l’intégration professionnelle de nos
        diplômés, en élargissant notre réseau de partenaires académiques et
        industriels à l’échelle nationale et internationale, et en renforçant la
        communication interne et externe.
      </p>

      <p className={styes.description}>
        <strong className="color-main">
          ► Agir avec responsabilité sociale et sociétale :
        </strong>{" "}
        Par la mise en œuvre d’une gouvernance transparente, la gestion
        efficiente des ressources, le respect de la propriété intellectuelle, de
        l’éthique et l’intégration des principes de la responsabilité sociétale
        des organisations (RSE).
      </p>

      <p className={styes.description}>
        <strong className="color-main">
          ► S’engager pour les justices sociale, raciale et climatique :{" "}
        </strong>{" "}
        L’UIK promeut activement les valeurs d’inclusion, de diversité et de
        durabilité, et œuvre pour une société équitable, respectueuse de
        l’environnement et des droits humains.
      </p>

      <p className={styes.description}>
        Nous nous engageons, en tant que direction de l’UIK, à mobiliser toutes
        les ressources nécessaires pour le déploiement du SMOE, à satisfaire aux
        exigences légales et normatives, et à améliorer continuellement son
        efficacité et son efficience. Nous veillons à ce que cette politique
        soit comprise et partagée à tous les niveaux de l’université, en
        favorisant l’implication active de l’ensemble des parties prenantes pour
        atteindre les objectifs de performance de notre système de management
      </p>

      <h3
        className={styes.h3}
        style={{
          textAlign: "center",
        }}
      >
        La Direction
      </h3>

      {/* <p className={styes.description}>
        - 2 photographies d’identité <br />
        - 3 formulaires de visa remis par le Consulat tunisien <br />
        - Photocopie des 3 premières pages de votre passeport <br />- Photocopie
        de l’attestation d’inscription et du reçu de paiement
      </p>

      <p className={styes.description}>
        Les délais pour obtenir le visa peuvent être longs et varient selon
        votre pays de résidence. Il est donc important d’entreprendre vos
        démarches dès que vous avez reçu votre inscription définitive de
        l’Université. Veillez à formuler votre demande de visa suffisamment tôt.
      </p>

      <h3 className={styes.h4}>B - Carte de Séjour </h3>

      <p className={styes.description}>
        Lorsque vous arrivez à Tunis et vous installez, il est impératif de
        déposer votre demande de carte de séjour dans un délai d'un mois
        maximum. Vous devez vous rendre au commissariat le plus proche de votre
        lieu de résidence pour effectuer cette demande. Les documents requis
        comprennent :
      </p>

      <ul className={styes.ul}>
        <li>
          Votre certificat d'inscription à l'université et le reçu de paiement
          des frais de scolarité.
        </li>
        <li>
          Votre contrat de location, ou si vous résidez en foyer, une
          attestation de résidence.
        </li>
        <li>Deux photos d'identité.</li>
        <li>
          Deux timbres fiscaux que vous pouvez obtenir à la Recette des
          Finances.
        </li>
        <li>
          Un justificatif de ressources bancaires et/ou une attestation de prise
          en charge.
        </li>
        <li>Un justificatif d'assurance maladie/accident.</li>
      </ul>

      <p className={styes.description}>
        La délivrance de la carte de séjour prendra environ 2 à 3 mois à partir
        de la date de dépôt de votre demande. Cette carte sera valide pendant un
        an, jusqu'au 30 septembre de l'année en cours, et vous devrez la
        renouveler chaque année. En attendant, le commissariat vous remettra une
        carte provisoire qui atteste de votre statut régulier sur l'ensemble du
        territoire tunisien.
      </p>

      <h2 className={styes.h2}>2 - Logement provisoire </h2>

      <p className={styes.description}>
        L'université Ibn Khaldoun propose des logements provisoires sur son
        campus aux nouveaux étudiants internationaux, leur offrant ainsi une
        solution pratique en attendant de trouver un logement individuel ou en
        colocation. Le bureau d'aide au logement de l'université se chargera par
        la suite de trouver un logement permanent aux étudiants selon leur
        budgets et leurs préférences.
      </p>

      <h2 className={styes.h2}>3 - Bureau d’aide à la recherche de logement</h2>

      <p className={styes.description}>
        Le bureau d'aide à la recherche de logement de l'université Ibn Khaldoun
        joue un rôle essentiel en trouvant des logements pour les nouveaux
        étudiants. Ce service s'engage à faciliter la transition des étudiants
        en leur offrant des solutions de logement adaptées à leurs besoins. Que
        ce soit en trouvant des chambres dans les résidences universitaires, en
        facilitant la recherche de colocations ou en fournissant des
        informations sur les offres de logements disponibles dans les environs
        de l'université, le bureau d'aide à la recherche de logement s'efforce
        de garantir que chaque nouvel étudiant puisse bénéficier d'un
        hébergement confortable et sûr dès son arrivée. Grâce à ses nombreuses
        connexions avec les propriétaires locaux et son large réseau
        d’étudiants, le bureau d’aide à la recherche de logement se consacre à
        trouver les meilleures options de logement, permettant ainsi aux
        étudiants de se concentrer pleinement sur leurs études et de s'intégrer
        facilement à la vie universitaire.
      </p>

      <h2 className={styes.h2}> 4 - Estimation des dépenses</h2> */}
    </div>
  );
}

export default PolitiqueQuality;
